let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1umXM")).then(() => parcelRequire('f7aUi'));